import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { format, getDay, parse, startOfWeek } from 'date-fns';
import enUS from 'date-fns/locale/en-US';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { getPromotionsAPI } from 'api';
import 'react-big-calendar/lib/addons/dragAndDrop/styles.css';
import 'react-big-calendar/lib/css/react-big-calendar.css';


const locales = {
  'en-US': enUS,
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const PromoCalendar = () => {
  const { promoData: { All = {} } } = useSelector((state) => (state.promo));

  const { promotions = [] } = All;
  const dispatch = useDispatch();

  useEffect(() => {
    getPromotionsAPI({dispatch, limit: 1000 });
  }, []);

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={promotions}
        titleAccessor="promoName"
        startAccessor="start"
        endAccessor="end"
        style={{ height: 800 }}
        views={['month', 'day']}
        eventPropGetter={
          (event) => {
            const newStyle = {
              backgroundColor: '#dfdfdf',
              color: 'black'
            };

            if (event.status === 'Published') {
              newStyle.backgroundColor = '#19cfd2';
            } else if (event.status === 'Started') {
              newStyle.backgroundColor = '#19d21e';
            } else if (event.status === 'Failed') {
              newStyle.backgroundColor = '#e2002e';
            }

            return {
              className: '',
              style: newStyle
            };
          }
        }
      />
    </div>
  );
};

export default PromoCalendar;
